module.exports = __webpack_public_path__ + "static/media/laliga.e03dcd29.svg";